const ENGINETYPE = {
  gas: 'gas',
  hybrid: 'hybrid',
  electric: 'electric',
  plugin: 'plug-in hybrid',
};

export default ENGINETYPE;
